export const SITE = {
  name: "Travel Passport and Visa LLC",
  siteName: "Travel Passport and Visa LLC",
  phoneDisplay: "866-334-8472",
  phoneTel: "tel:8663348472",
  phone2Display: "202-457-4665",
  phone2Tel: "tel:2024574665",
  addressLine1: "1629 K St NW, Suite 305",
  addressLine2: "Washington, DC 20006",
  years: "20+",
  disclosure:
    "Travel Passport and Visa LLC is a private courier company. It is not a government agency and is not affiliated with, endorsed by, or sponsored by the U.S. Department of State or any other government entity. Mandatory government fees are set by the U.S. Department of State, are paid to the government, and are in addition to our service fees. Processing times are estimates only; passport and visa issuance is controlled by the U.S. government and applicable embassies and cannot be guaranteed.",
  shortDisclosure:
    "Private service provider — not a government agency. Not affiliated with, endorsed by, or sponsored by the U.S. Department of State.",
  processingDisclaimer:
    "Processing times vary based on the applicable government agency, consulate, application type, eligibility, and current processing conditions. Any estimated timeframe is subject to change and is not guaranteed.",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1581553673739-c4906b5d0de8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  airport: "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  passport: "https://images.unsplash.com/photo-1655722725332-9925c96dd627?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  executive: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  dc: "https://images.unsplash.com/photo-1629671119816-f39d021f1037?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICE_OPTIONS = [
  "New Passport",
  "Passport Renewal",
  "Urgent Passport Assistance",
  "Child Passport",
  "Lost or Stolen Passport",
  "Visa Assistance",
  "Tourist Visa",
  "Business Visa",
  "Apostille Services",
  "Document Authentication",
  "Translation Services",
  "Other",
];
